import React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';

import { PATH } from '../../../../constants/path';

import HeadComponent from '../../../HeadComponent';
import { withTemplate } from '../../../template/withTemplate';
import { PrimaryTemplate } from '../../../template/PrimaryTemplate';
import DownloadBillFormComponent from './DownloadBillFormComponent';
import LocalizedBreadcrumbItem from '../../../breadcrumb/LocalizedBreadcrumbsItem';

const DownloadEbonBillPage = ({ i18n, orderId, email, hmac }) => {
    return (
        <main className="conteneur conteneur-mobile" id="p-bill">
            <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
            <LocalizedBreadcrumbItem to={PATH.EBON_DOWNLOAD_BILL_PATH}>
                {i18n.BREADCRUMB}
            </LocalizedBreadcrumbItem>
            <h1>{i18n.TITLE}</h1>

            <DownloadBillFormComponent orderId={orderId} email={email} hmac={hmac} />
        </main>
    );
};

const mapStateToProps = state => {
    const locationParsed = queryString.parse(window.location.search);

    return {
        i18n: state.i18n.page.EBON.BILL,
        orderId: locationParsed.orderId,
        email: locationParsed.email,
        hmac: locationParsed.hmac
    };
};

export default withTemplate(connect(mapStateToProps)(DownloadEbonBillPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/download/DownloadEbonBillPage.js